import React from "react";
import {
  CONSULT_SIDEBAR_WIDTH,
  CONSULT_SIDEBAR_WIDTH_ICON,
} from "./ConsultationSidebar";

interface ConsultationLayoutProps {
  sidebar: React.ReactNode;
  children: React.ReactNode;
  rightPanel: React.ReactNode;
  isSidebarCollapsed?: boolean;
}

/**
 * Consultation Layout — three-column shell.
 * Left: collapsible sidebar, Center: main content, Right: context panel.
 */
export const ConsultationLayout = ({
  sidebar,
  children,
  rightPanel,
  isSidebarCollapsed = false,
}: ConsultationLayoutProps) => {
  return (
    <div className="min-h-screen w-full flex flex-col lg:flex-row bg-surface font-sans">
      {/* Left Sidebar */}
      <aside
        className="shrink-0 z-20 transition-[width] duration-300 ease-in-out hidden md:block h-screen sticky top-0"
        style={{
          width: isSidebarCollapsed
            ? CONSULT_SIDEBAR_WIDTH_ICON
            : CONSULT_SIDEBAR_WIDTH,
        }}
      >
        {sidebar}
      </aside>

      {/* Main Content */}
      <main className="flex-1 flex flex-col min-w-0 p-4 h-screen">
        {children}
      </main>

      {/* Right Context Panel */}
      <aside className="w-full lg:w-80 shrink-0 pr-4 pb-4 lg:pl-0 z-10 lg:h-screen lg:sticky lg:top-0">
        <div className="h-full overflow-hidden flex flex-col">{rightPanel}</div>
      </aside>
    </div>
  );
};
